import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const POPUP_KEY = 'audioFeaturePopupShown';
const EXPIRY_DATE = '2026-02-19'; // 30 days from deployment

const AudioFeaturePopup = () => {
  const [show, setShow] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    const now = new Date();
    const expiry = new Date(EXPIRY_DATE);
    if (now > expiry) return;

    if (!localStorage.getItem(POPUP_KEY)) {
      setTimeout(() => setShow(true), 2000);
    }
  }, []);

  const dismiss = () => {
    localStorage.setItem(POPUP_KEY, 'true');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '24px',
        maxWidth: '400px',
        margin: '20px',
        textAlign: 'center',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
      }}>
        <div style={{
          fontSize: '3rem',
          marginBottom: '12px'
        }}>
          🔊
        </div>
        <h2 style={{
          color: '#4f46e5',
          marginTop: 0,
          marginBottom: '16px',
          fontSize: '1.5rem'
        }}>
          {t('audioFeature.popupTitle')}
        </h2>
        <p style={{
          color: '#374151',
          lineHeight: '1.6',
          marginBottom: '20px'
        }}>
          {t('audioFeature.popupContent')}
        </p>
        <button
          onClick={dismiss}
          style={{
            backgroundColor: '#4f46e5',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            padding: '12px 24px',
            fontSize: '1rem',
            fontWeight: '600',
            cursor: 'pointer'
          }}
        >
          {t('audioFeature.gotIt')}
        </button>
      </div>
    </div>
  );
};

export default AudioFeaturePopup;
